// <s-collection-filter> filters a list of collection cards as the shopper types.
// Reads [data-filter-input], [data-filter-item][data-filter-name], [data-filter-status],
// [data-filter-empty] and the --clear command. Status text comes from data-status-template
// with __SHOWN__ and __TOTAL__ placeholders so it stays translated.
class SCollectionFilter extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const { signal } = this.#ac;
    this.input = this.querySelector('[data-filter-input]');
    this.items = [...this.querySelectorAll('[data-filter-item]')];
    this.status = this.querySelector('[data-filter-status]');
    this.empty = this.querySelector('[data-filter-empty]');
    this.clear = this.querySelector('[data-filter-clear]');

    this.input?.addEventListener('input', () => this.#apply(), { signal });
    this.addEventListener('command', (event) => {
      if (event.command === '--clear' && this.input) {
        this.input.value = '';
        this.#apply();
        this.input.focus();
      }
    }, { signal });
    this.#apply();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #apply() {
    const query = (this.input?.value || '').trim().toLowerCase();
    let shown = 0;
    for (const item of this.items) {
      const match = !query || (item.dataset.filterName || '').includes(query);
      item.hidden = !match;
      if (match) shown += 1;
    }
    if (this.clear) this.clear.hidden = !query;
    if (this.empty) this.empty.hidden = shown > 0;
    if (this.status) {
      const template = this.dataset.statusTemplate || '';
      this.status.textContent = query
        ? template.replace('__SHOWN__', shown).replace('__TOTAL__', this.items.length)
        : '';
    }
  }
}

if (!customElements.get('s-collection-filter')) {
  customElements.define('s-collection-filter', SCollectionFilter);
}
